var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSoundMute = function SvgSoundMute(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.388 1.75v20.753l-8.134-6.1h-4.98V7.85h4.98l8.134-6.101Zm-1.25 2.5L6.67 9.1H2.524v6.052H6.67l6.468 4.851V4.25ZM16.515 8.4a.625.625 0 0 1 .884 0c2.07 2.069 2.07 5.294 0 7.363a.625.625 0 1 1-.884-.884c1.582-1.581 1.582-4.014 0-5.596a.625.625 0 0 1 0-.884Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.162 5.935a.625.625 0 0 1 .884 0c3.438 3.438 3.438 9.036 0 12.475a.625.625 0 1 1-.884-.884c2.95-2.95 2.95-7.757 0-10.707a.625.625 0 0 1 0-.884Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m20.558 20.942-17.5-17.5.884-.884 17.5 17.5-.884.884Z",
    fill: "currentColor"
  })));
};
export default SvgSoundMute;